import {createSvgIcon} from '../create-svg-icon';

export const HMobiledataIcon = createSvgIcon(
  <path d="M15 11H9V7H7v10h2v-4h6v4h2V7h-2v4z" />
, 'HMobiledataOutlined');
